import { AlertTriangle, CheckCircle2, Layers3, Target } from "lucide-react";
import { SearchResultCard } from "./SearchResultCard";

const icons = { exact: CheckCircle2, likely_intended: Target, variants: Layers3, alternatives: AlertTriangle };

export const SearchBucketSection = ({ bucketKey, bucket, copy, onChoose, startIndex = 0, view = "grid", compared = [], onCompare, onQuestion }) => {
  if (!bucket?.items?.length) return null;
  const Icon = icons[bucketKey];
  return (
    <section className={`search-bucket search-bucket-${bucketKey}`} data-testid={`search-bucket-${bucketKey}`}>
      <header className="search-bucket-heading">
        <div>
          <span><Icon aria-hidden="true" />{copy.buckets[bucketKey]}</span>
          <p>{copy.bucketDescriptions[bucketKey]}</p>
        </div>
        <strong data-testid={`search-bucket-${bucketKey}-count`}>{bucket.count}</strong>
      </header>
      <div className={`search-results-grid is-${view}`}>
        {bucket.items.map((item, index) => (
          <SearchResultCard key={item.article_id} item={item} index={startIndex + index} onChoose={onChoose} copy={copy} selected={compared.some(row => row.article_id === item.article_id)} onCompare={onCompare} onQuestion={onQuestion} />
        ))}
      </div>
    </section>
  );
};